<template>
  <div class="text-center">
    <distribution-of-transfers-per-bank-chart
      v-show="!showBlankslate"
      :date-range="dateRange"
      :on-load="onLoad"
      :height="'170vh'"
    />
    <img
      v-show="showBlankslate"
      :src="'/assets/img/blankslate/blankslate-round-chart.svg'"
    >
  </div>
</template>

<script>
import DistributionOfTransfersPerBankChart from '@/apps/payments/payments/indicator/components/presentational/DistributionOfTransfersPerBankChart';

export default {
  name: 'distribution-of-transfers-per-bank-chart-container',
  components: {
    DistributionOfTransfersPerBankChart
  },
  props: {
    dateRange: {
      required: true
    }
  },
  data: () => ({
    showBlankslate: false
  }),
  watch: {
    dateRange: {
      deep: true,
      handler() {
        this.showBlankslate = false;
      }
    }
  },
  methods: {
    onLoad(data) {
      if (!data.length) {
        this.showBlankslate = true;
      }
    }
  }
};
</script>
